import * as Yup from 'yup'

export const initialValues = initialValue => ({
    minCapacity: initialValue?.minCapacity || 3000,
    maxCapacity: initialValue?.maxCapacity || 10000,
    forkLength: initialValue?.forkLength || 0,
    fuelType: initialValue?.fuelType || 'All',
    tireGroup: initialValue?.tireGroup || '',
    categories: initialValue?.selectedCategory || '',
    comments: initialValue?.comments || '',
    deliverToAccountId: initialValue?.deliverToAccountId || '',
    requestType: initialValue?.requestType || '',
})

export const validationSchema = Yup.object().shape({
    minCapacity: Yup.number().required('Min capacity is required'),
    maxCapacity: Yup.number().required('Max capacity is required'),
    forkLength: Yup.string(),
    fuelType: Yup.string().required('Fuel Type is required'),
    tireGroup: Yup.string(),
    categories: Yup.string().required('Category is required'),
    comments: Yup.string().max(
        255,
        'Comments too long (maximum 255 characters)',
    ),
    deliverToAccountId: Yup.string().required('The location is required'),
    requestType: Yup.string().required('Request type is required'),
})
